module.exports = __webpack_public_path__ + "img/left-arrow-circle.76420aff.svg";